import React from 'react';
import styles from './ConfirmationPopUp.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';

const ConfirmationPopUp = ({ isVisible, onClose, onConfirm, message }) => {
    if (!isVisible) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                <p className={styles.text}>{message || "Are you sure?"}</p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    <div style={{ width: '74px', height: '25px' }}>
                        <button onClick={onConfirm} className={buttonStyles.YesButtonComponentStyling}>
                            CONFIRM
                        </button>
                    </div>
                    <div style={{ width: '74px', height: '25px', marginLeft: '10px' }}>
                        <button onClick={onClose} className={buttonStyles.NoButtonComponentStyling}>
                            CANCEL
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PostcodeWarningPopUp = ({ isVisible, onClose, onContinue, postcode, existingProjects }) => {
    if (!isVisible) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                <p className={styles.text}>
                    <strong>Warning:</strong> The postcode <strong>{postcode}</strong> already exists with {existingProjects.length} other project{existingProjects.length !== 1 ? 's' : ''}.
                    <br /><br />
                    {existingProjects.length <= 3 ? (
                        <>
                            Existing project{existingProjects.length !== 1 ? 's' : ''}:
                            <br />
                            {existingProjects.map(project => (
                                <span key={project.jobno}>
                                    • {project.jobno}: {project.projectaddress}
                                    <br />
                                </span>
                            ))}
                        </>
                    ) : (
                        <>
                            First {existingProjects.length} matching projects:
                            <br />
                            {existingProjects.slice(0, 3).map(project => (
                                <span key={project.jobno}>
                                    • {project.jobno}: {project.projectaddress}
                                    <br />
                                </span>
                            ))}
                            And {existingProjects.length - 3} more...
                        </>
                    )}
                    <br />
                    Do you want to continue creating a new project number anyway?
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    <div style={{ width: '100px', height: '25px' }}>
                        <button onClick={onContinue} className={buttonStyles.YesButtonComponentStyling}>
                            CONTINUE
                        </button>
                    </div>
                    <div style={{ width: '74px', height: '25px', marginLeft: '10px' }}>
                        <button onClick={onClose} className={buttonStyles.NoButtonComponentStyling}>
                            CANCEL
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { PostcodeWarningPopUp };
export default ConfirmationPopUp;
